import { render, staticRenderFns } from "./DetalleDePago.vue?vue&type=template&id=017064c9&scoped=true&"
import script from "./DetalleDePago.vue?vue&type=script&lang=js&"
export * from "./DetalleDePago.vue?vue&type=script&lang=js&"
import style0 from "./DetalleDePago.vue?vue&type=style&index=0&id=017064c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017064c9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VFlex,
  VIcon,
  VLayout,
})
